{
  "Basic": [
    {
      "menu_label": "Global Participant Search",
      "menu_id": "globalConsumerSearch",
      "display": "y",
      "landing_component": "globalConsumerSearch"
    },
    {
      "menu_label": "Participant Referral",
      "menu_id": "consumerReferral",
      "display": "y",
      "landing_component": "referralList"
    },
    {
      "menu_label": "Participant Enrollment",
      "menu_id": "consumerRegistration",
      "landing_component": "participantEnrollmentList",
      "display": "y"
    },
    {
      "menu_label": "Association Enrollment",
      "menu_id": "personalAssistantRegistration",
      "landing_component": "providerEnrollmentList",
      "display": "y"
    }
  ],
  "Timesheets": [
    {
      "menu_label": "Timesheets",
      "menu_id": "timesheets",
      "display": "y",
      "landing_component": "timesheet"
    },
    {
      "menu_label": "Pended Timesheets",
      "menu_id": "pendedTimesheets",
      "display": "y",
      "landing_component": "pendedTimesheets"
    },
    {
      "menu_label": "Authorizations",
      "menu_id": "authorizations",
      "display": "y",
      "landing_component": "authorizations"
    }
  ],
  "Invoices": [
    {
      "menu_label": "Invoices",
      "menu_id": "invoices",
      "display": "y",
      "landing_component": "invoices"
    }
  ],
  "Purchase Requests": [
    {
      "menu_label": "Purchase Requests",
      "menu_id": "purchaseRequests",
      "display": "y",
      "landing_component": "purchaseRequests"
    }
  ],
  "Others": [
    {
      "menu_label": "Independent Facilitator",
      "menu_id": "independentFacilitator",
      "display": "y",
      "landing_component": "caseManagerList"
    },
    {
      "menu_label": "Process Codes",
      "menu_id": "processCodes",
      "display": "n",
      "landing_component": "processCodeList"
    },
    {
      "menu_label": "Service Codes",
      "menu_id": "serviceCodes",
      "display": "n",
      "landing_component": "serviceCodeList"
    },
    {
      "menu_label": "Config",
      "menu_id": "applicationConfig",
      "display": "n",
      "landing_component": "configList"
    },
    {
      "menu_label": "File Triage",
      "menu_id": "fileTriage",
      "display": "y",
      "landing_component": "fileTriage"
    },
    {
      "menu_label": "File Upload Notification",
      "menu_id": "fileUploadNotification",
      "display": "y",
      "landing_component": "fileUploadNotification"
    }
  ],
  "Payroll Adjustments": [
    {
      "menu_label": "Timesheet Adjustments",
      "menu_id": "payrollAdjustment",
      "display": "y",
      "landing_component": "payrollAdjustment"
    },
    {
      "menu_label": "Invoice Adjustments",
      "menu_id": "invoiceAdjustments",
      "display": "y",
      "landing_component": "invoiceAdjustment"
    },
    {
      "menu_label": "Purchase Adjustments",
      "menu_id": "purchaseAdjustments",
      "display": "y",
      "landing_component": "purchaseAdjustment"
    },
    {
      "menu_label": "Bulk Adjustments",
      "menu_id": "bulkAdjustments",
      "display": "y",
      "landing_component": "bulkAdjustments"
    },
    {
      "menu_label": "Billing Adjustments",
      "menu_id": "billingAdjustment",
      "display": "y",
      "landing_component": "billingAdjustment"
    }
  ],
  "Payroll Approvals": [
    {
      "menu_label": "Timesheet Approvals",
      "menu_id": "payrollApprovals",
      "display": "y",
      "landing_component": "payrollApprovals"
    },
    {
      "menu_label": "Invoice Approvals",
      "menu_id": "invoiceApprovals",
      "display": "y",
      "landing_component": "invoiceApprovals"
    },
    {
      "menu_label": "Purchase Request Approvals",
      "menu_id": "purchaseRequestApprovals",
      "display": "y",
      "landing_component": "purchaseRequestApprovals"
    }
  ],
  "Other Payroll Actions": [
    {
      "menu_label": "Payroll Resurrect",
      "menu_id": "payrollResurrect",
      "display": "y",
      "landing_component": "payrollResurrect"
    }
  ]
}